import React, { FC, ReactNode } from 'react';
import styles from './modal_scrollable_header.module.scss';
import { MaterialIcon } from '../../../material-icon/MaterialIcon';

type Props = {
  title?: string | ReactNode;
  onClose: () => void;
};

export const ModalScrollableHeader: FC<Props> = ({ title = '', onClose }) => (
  <div className={styles.container}>
    <div className={styles.title}>{title}</div>
    <div
      className={styles.close}
      onClick={onClose}
      data-test-id="modal-scrollable-header-close"
    >
      <MaterialIcon name="close" className={styles.icon} />
    </div>
  </div>
);
